import * as React from "react"
import { cn } from "~/lib/utils"

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  largeClickArea?: boolean
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, largeClickArea, ...props }, ref) => {
    const checkbox = (
      <input
        type="checkbox"
        ref={ref}
        className={cn("h-checkbox", className)}
        {...props}
      />
    )

    if (largeClickArea) {
      return <label className="h-checkbox-wrapper">{checkbox}</label>
    }

    return checkbox
  },
)

Checkbox.displayName = "Checkbox"

export { Checkbox }
